import { Injectable } from '@angular/core';
import { AppSessionService } from '@shared/session/app-session.service';
import { PermissionConsts, USER_GET_ALL_PERMISSIONS } from '@shared/permission-consts';
import { PermissionsValueStore } from '@shared/services/permissions-values.store';

@Injectable({
    providedIn: 'root',
})
export class EntryPointManagerService {
    constructor(
        private session: AppSessionService,
        private permissionValueStore: PermissionsValueStore,
    ) {}

    selectEntryPoint(): string {
        if (!this.session.user) {
            return '/account/login';
        }

        if (this.permissionValueStore.isGranted(PermissionConsts.Role_OperatorLike)) {
            return '/app/dashboard';
        }

        if (this.permissionValueStore.isGranted(PermissionConsts.Service_List)) {
            return '/app/services';
        }

        if (this.permissionValueStore.isGranted(USER_GET_ALL_PERMISSIONS)) {
            return '/app/users';
        }

        if (this.permissionValueStore.isGranted(PermissionConsts.Role_GetAll)) {
            return '/app/roles';
        }

        return '/fallback/no-permissions';
    }
}
